import React from 'react'
import { ShoppingCart, Star } from '@mui/icons-material'

const ProductDetail = ({ products, buttonAction }) => {
    const pathname = window.location.pathname.slice(10)

    const id = parseInt(pathname) 
    const product = products.find((i) => i.id === id)
  return (
    <div className='flex flex-col space-y-4 p-2 bg-white min-h-[100vh]'>
        <div className='flex flex-col md:flex-row'>

        <img className='rounded-lg w-[600px] h-[600px]' src={product.img} alt='shoe' />
        <div className='flex flex-col space-y-10 p-4'>
        <div className='flex flex-col space-y-2 '>
            <p className='font-bold'>Name: {product.name}</p>
            <p className='text-green-600 font-bold text-sm'>Price: ${product.price}</p>
            <p className='font-bold text-sm text-gray-500'>Description: {product.description}</p>
            <p className='font-bold text-gray-500'>Deliver: {product.deliver} (10 - 18 Days)</p>
            <p className='font-bold'>Condition: {product.condition}</p>
            <p className='font-bold'>Material: {product.material}</p>
            <p className='font-bold text-blue-500'>In Stock: {product.stock} pairs</p>
            <p className='font-bold flex text-orange-500 text-sm'>
              Rating: 
            {product.rating.rate > 0 && product.rating.rate <2 &&
             <Star fontSize='small' color='orange'/>
             }
            {product.rating.rate > 1.99 && product.rating.rate <3 &&
            <div className='flex '>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
            </div>
             }
            {product.rating.rate > 2.99 && product.rating.rate <4 &&
             <div className='flex '>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
            </div>
            }
            {product.rating.rate > 3.99 && product.rating.rate <5 &&
             <div className='flex '>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
            </div>
            }
            {product.rating.rate > 4.99 &&
             <div className='flex '>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
              <Star fontSize='small' color='orange'/>
            </div>
            }
            </p>
            <div className='flex space-x-2 mt-4 items-center'>
            <img className='w-[50px] h-[50px] rounded-full' src={product.img} alt={product.name}/>
            <p className='font-semibold'>Seller's Name</p>
            </div>
        </div>
        <div className='flex  space-x-2'>
            <button onClick={() => buttonAction('add', product.id, 1, product ) } className='bg-black font-semibold text-white p-2 rounded-[5px]'>Add to cart <ShoppingCart/></button>
            <button onClick={() => buttonAction('add', product.id, 1, product ) } className='bg-orange-500 font-semibold text-white p-2 rounded-[5px]'>Rate <Star/></button>
        </div>
        </div>
        </div>
        <div className='flex space-x-4 items-center p-4 overflow-auto'>
            <p className='font-bold md:text-2xl text-blue-500'>
                Related products:
            </p>
            <div className='flex space-x-10'>
                {products.map((related, index) => (
                <div className={`scale flex flex-col ${related.id === id && 'hidden'}`}>
                    <img src={related.img} alt='jordans' className='bg-orange-500 rounded-lg w-[80px] h-[80px]'/>
                    {/* <p className='font-bold text-sm'>{related.name}</p> */}
                </div>
                ))}
            </div>
        </div>
    </div>
  )
}

export default ProductDetail